import { SparkTerms } from '../BuyTokensModal.styles';

const BuyTokensTermsCheckbox = ({ checked, onChange, translations }) => (
	<SparkTerms>
		<input type="checkbox" checked={checked} onChange={onChange} />
		<span>
			{translations.acceptTermsPrefix}{' '}
			<a
				href="/SoftAI regulamin terms of use.pdf"
				target="_blank"
				rel="noopener noreferrer"
				aria-label={translations.termsOfService}
			>
				{translations.termsOfService}
			</a>{' '}
			{translations.acceptTermsAnd}{' '}
			<a
				href="/PRIVACY POLICY.pdf"
				target="_blank"
				rel="noopener noreferrer"
				aria-label={translations.privacyPolicy}
			>
				{translations.privacyPolicy}
			</a>
			.
		</span>
	</SparkTerms>
);

export default BuyTokensTermsCheckbox;
